export default __webpack_public_path__ + "static/media/TrustAlice Icon.f52bd3e6.svg";